import {PATH} from '@/routes';

export const redirectToQuiz: () => void = () => {
  window.location.href = PATH.QUIZ;
};
